(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("takeExamQuestion", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/account/exam/takeExamQuestionView.html",
            controller: ["Upload", "authService", "takeExamResource", "messageService", "$state", "$scope", "$timeout", "$uibModal", TakeExamQuestionCtrl],
            controllerAs: "vm"
        };
        function TakeExamQuestionCtrl(Upload, authService, takeExamResource, messageService, $state, $scope, $timeout, $uibModal) {
            var vm = this;
            var timer;
            vm.pageLoaded = false;
            vm.buttonClicked = false;
            vm.examInfo = angular.copy($state.params.examInfo);
            vm.learnerName = authService.authentication.userFirstName + " " + authService.authentication.userLastName;
            loadQuestion();
            ////////////////////////////////////////
            // GET QUESTION
            function loadQuestion() {
                timer = new Date().getTime();
                takeExamResource.getQuestionViewModel({ examAttemptId: vm.examInfo.examAttemptId, questionNumber: vm.examInfo.questionNumber }, function (examQuestion) {
                    if (!examQuestion.isProctorValid) {
                        messageService.error("exams.takeExam.error.InvalidProctor");
                        $state.go("main.accountExam", { assignmentId: examQuestion.assignmentId });
                        return;
                    }
                    vm.examQuestion = examQuestion;
                    vm.saving = false;
                    vm.pageLoaded = true;
                    vm.selectedAnswer = vm.examQuestion.selectedAnswer;
                    vm.selectedAnswers = vm.examQuestion.selectedAnswers;
                    if (vm.examInfo.isTimed) {
                        $timeout(function () {
                            $scope.$broadcast("timer-set-countdown-seconds", examQuestion.timeLeft);
                        });
                    }
                }, function (error) {
                    messageService.error(error);
                    vm.loading = false;
                });
            }
            //SAVE MULTIPLE CHOICE
            vm.answerSelected = function () {
                var now = new Date().getTime();
                var timeSpent = Math.round((now - timer) / 1000);
                timer = now;
                var multipleChoiceAnswer = {
                    id: vm.examQuestion.id,
                    SelectedAnswer: vm.selectedAnswer,
                    SelectedAnswers: vm.selectedAnswers,
                    timeSpent: timeSpent
                };
                takeExamResource.saveMultipleChoice({ examAttemptId: vm.examInfo.examAttemptId, questionNumber: vm.examInfo.questionNumber }, multipleChoiceAnswer, function () {
                }, function (error) {
                    messageService.error(error);
                });
            };
            //FILE UPLOAD
            vm.upload = function (file) {
                if (file) {
                    file.upload = Upload.upload({
                        url: "api/takeExam/" + vm.examInfo.examAttemptId + "/" + vm.examInfo.questionNumber + "/fileUpload",
                        data: {
                            file: file
                        }
                    });
                    file.upload.then(function (response) {
                        vm.examQuestion.fileUploadName = response.data.fileUploadName;
                        vm.examQuestion.fileUploadUrl = response.data.fileUploadUrl;
                        messageService.success("common.dropzone.uploadedFileMessage");
                        vm.progress = 0;
                    }, function (error) {
                        messageService.error(error);
                        vm.progress = 0;
                    }, function (evt) {
                        file.progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                    });
                }
            };
            vm.deleteFile = function () {
                var modal = $uibModal.open({
                    templateUrl: "deleteExamQuestionFileConfirmation.html",
                    backdrop: false,
                    animation: false,
                    windowClass: "confirmation-modal"
                });
                modal.result.then(function () {
                    takeExamResource.deleteFileUpload({ examAttemptId: vm.examInfo.examAttemptId, questionNumber: vm.examInfo.questionNumber }, function () {
                        vm.examQuestion.fileUploadName = "";
                        vm.examQuestion.fileUploadUrl = "";
                        messageService.success("common.fileDeleted");
                    }, function (error) {
                        messageService.error(error);
                    });
                }).catch(angular.noop);
            };
            //NAVIGATION
            vm.continue = function () {
                if (vm.saving)
                    return;
                vm.saving = true;
                saveAnswer(function () {
                    if (vm.examInfo.questionNumber === vm.examQuestion.totalQuestions)
                        $state.go("main.accountExamSummary", { examInfo: vm.examInfo });
                    else {
                        vm.examInfo.questionNumber++;
                        loadQuestion();
                    }
                });
            };
            vm.back = function () {
                saveAnswer(function () {
                    if (vm.examInfo.questionNumber > 1) {
                        vm.examInfo.questionNumber--;
                        loadQuestion();
                    }
                });
            };
            vm.summary = function () {
                saveAnswer(function () {
                    $state.go("main.accountExamSummary", { examInfo: vm.examInfo });
                });
            };
            vm.autoSaveLongAnswer = function () {
                saveAnswer();
            };
            //SAVE
            var saveAnswer = function (successCallback) {
                if (vm.examQuestion.questionType === "LongAnswer" && vm.longAnswerForm.$dirty) {
                    var now = new Date().getTime();
                    var timeSpent = Math.round((now - timer) / 1000);
                    timer = now;
                    var longAnswer = {
                        id: vm.examQuestion.id,
                        longAnswer: vm.examQuestion.longAnswer,
                        timeSpent: timeSpent
                    };
                    vm.longAnswerForm.$setPristine();
                    takeExamResource.saveLongAnswer({ examAttemptId: vm.examInfo.examAttemptId, questionNumber: vm.examInfo.questionNumber }, longAnswer, function () {
                        if (successCallback)
                            successCallback();
                    }, function (error) {
                        vm.longAnswerForm.$setDirty();
                        messageService.error(error);
                    });
                }
                else {
                    if (successCallback)
                        successCallback();
                }
            };
            //TIME EXPIRED
            vm.timeExpired = function () {
                $state.go("main.accountExamResult", { examInfo: vm.examInfo });
            };
        }
    });
}());
